"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL = exports.mapPresentationToV2 = void 0;
const ApiClient_1 = __importDefault(require("./ApiClient"));
exports.default = ApiClient_1.default;
__exportStar(require("./ApiClient"), exports);
var PresentationClient_1 = require("./PresentationClient");
Object.defineProperty(exports, "mapPresentationToV2", { enumerable: true, get: function () { return PresentationClient_1.mapPresentationToV2; } });
__exportStar(require("./types/Application"), exports);
__exportStar(require("./types/Chargebee"), exports);
__exportStar(require("./types/Device"), exports);
__exportStar(require("./types/Domain"), exports);
__exportStar(require("./types/Folder"), exports);
__exportStar(require("./types/PlaybackReport"), exports);
__exportStar(require("./types/Playlist"), exports);
__exportStar(require("./types/Presentation"), exports);
__exportStar(require("./types/Product"), exports);
__exportStar(require("./types/Resource"), exports);
__exportStar(require("./types/Theme"), exports);
__exportStar(require("./types/User"), exports);
__exportStar(require("./types/Invoice"), exports);
__exportStar(require("./types/Payment"), exports);
__exportStar(require("./types/Api"), exports);
__exportStar(require("./types/Country"), exports);
__exportStar(require("./types/Address"), exports);
__exportStar(require("./types/PaymentMethod"), exports);
__exportStar(require("./types/Admin"), exports);
__exportStar(require("./types/BatchDeviceSettings"), exports);
__exportStar(require("./types/Analytics"), exports);
__exportStar(require("./types/Catalog"), exports);
__exportStar(require("./types/Connection"), exports);
__exportStar(require("./types/Paginated"), exports);
__exportStar(require("./types/Location"), exports);
__exportStar(require("./types/Connector"), exports);
__exportStar(require("./types/Library"), exports);
var urls_1 = require("./urls");
Object.defineProperty(exports, "URL", { enumerable: true, get: function () { return __importDefault(urls_1).default; } });
__exportStar(require("./errors"), exports);
